import { buildStreetLabelMap, householdLabel } from '../adressHelpers/buildStreetLabels'

/**
 * Bepaalt de naam van de respondent boven de onderzoeksresultaten. Een
 * vragenlijst kan aan een deelnemer/medewerker (Personas) óf aan een
 * huishouden (Adresses) gekoppeld zijn — beide worden op het antwoord in
 * hetzelfde veld (`Persona`) opgeslagen, dus de kop moet allebei aankunnen.
 *
 * @param {object} args
 * @param {Array<{Name?: string}>} [args.personas] - Personas-documenten voor deze respondent-ID (leeg bij een huishouden)
 * @param {Array<{ID?: string, Title?: string}>} [args.adresses] - Adresses-documenten voor deze respondent-ID (leeg bij een deelnemer)
 * @param {Array<{PersonaID?: string, Title?: string, Value?: string}>} [args.personaDataRows] - PersonaData-rijen met Straatnaam/Huisnummer
 * @returns {string} Naam van de respondent, of '' als die onbekend is
 */
const resolveRespondentTitle = ({ personas, adresses, personaDataRows } = {}) => {
    const persona = (Array.isArray(personas) ? personas : []).find((p) => p?.Name)
    if (persona) return persona.Name

    const adress = (Array.isArray(adresses) ? adresses : [])[0]
    if (!adress) return ''

    // Met het huishouden erbij: straat en nummer zijn vaste gegevens (T9).
    return householdLabel(buildStreetLabelMap(personaDataRows, adress ? [adress] : []), adress)
}

export default resolveRespondentTitle
